import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('validateDrawing');

    return {
        IS_MINIMUM_POINTS: t('isMinimumPoints'),
        OVERLAPPING: t('overlapping'),
        SELF_INTERSECTING: t('selfIntersecting')
    };
};

export default useTranslation;
